var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { ref, computed } from "vue";
class RemoteDataSource {
  constructor(remoteFetchCallback) {
    // Data and metas
    __publicField(this, "data", ref([]));
    __publicField(this, "total", ref(0));
    __publicField(this, "pages", ref(0));
    // Query
    __publicField(this, "sort", ref(null));
    __publicField(this, "globalTextSearchFilter", ref(null));
    __publicField(this, "globalFilters", ref(null));
    __publicField(this, "filters", ref(null));
    // Pagination
    __publicField(this, "pageSize", ref(10));
    __publicField(this, "page", ref(1));
    __publicField(this, "remoteFetchCallback", async () => []);
    this.remoteFetchCallback = remoteFetchCallback;
  }
  setPageSize(pageSize) {
    this.pageSize.value = pageSize;
  }
  setPage(page) {
    this.page.value = page;
  }
  getDataAndMetas() {
    return {
      data: computed(() => this.data.value),
      total: computed(() => this.total.value),
      pages: computed(() => this.pages.value)
    };
  }
  reset() {
    this.data.value = [];
    this.total.value = 0;
    this.pages.value = 0;
    this.sort.value = null;
    this.globalTextSearchFilter.value = null;
    this.globalFilters.value = null;
    this.pageSize.value = 10;
    this.page.value = 1;
  }
  async load() {
    const params = {
      skip: (this.page.value - 1) * this.pageSize.value,
      limit: this.pageSize.value
    };
    if (this.sort.value) {
      params.sort = this.sort.value;
    }
    const filters = {
      ...this.globalFilters.value ?? {},
      ...this.filters.value ?? {}
    };
    if (Object.keys(filters).length) {
      params["filter"] = JSON.stringify(filters);
    }
    const response = await this.remoteFetchCallback(params);
    this.data.value = response.data;
    this.total.value = response.metas.total;
    this.pages.value = response.metas.pageCount;
  }
  sortBy(attribute, direction) {
    this.sort.value = attribute ? `${direction === "asc" ? "+" : "-"}${attribute}` : null;
  }
  search(filterExpression) {
    console.log("filterExpression", filterExpression);
    this.globalTextSearchFilter.value = filterExpression && filterExpression.length ? filterExpression : null;
  }
  setGlobalFilters(filters) {
    this.globalFilters.value = filters;
  }
  clearGlobalFilters() {
    this.globalFilters.value = null;
  }
  setFilters(filters) {
    this.filters.value = filters;
  }
  clearFilters() {
    this.filters.value = null;
  }
}
const useRemoteDatasource = (remoteFetchCallback) => {
  return new RemoteDataSource(remoteFetchCallback);
};
export {
  RemoteDataSource,
  useRemoteDatasource
};
//# sourceMappingURL=remote-datasources.es.js.map
